import { render, staticRenderFns } from "./ProductionTrendsSkeleton.vue?vue&type=template&id=2e3b2876&scoped=true"
import script from "./ProductionTrendsSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductionTrendsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ProductionTrendsSkeleton.vue?vue&type=style&index=0&id=2e3b2876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3b2876",
  null
  
)

export default component.exports